import { MutationTree } from 'vuex';
import { QUESTIONS } from '../mutation_types';
import { IQUESTIONSSTATE } from '../state.d';

const state: IQUESTIONSSTATE = {
  manage: {
    removeData: [],
    removeFlag: false,
  },
};

/* eslint-disable no-param-reassign */
const mutations: MutationTree<IQUESTIONSSTATE> = {
  [QUESTIONS.SET_ASSET_MANAGE_REMOVE_DATA]: (s, data: Array<any>) => {
    s.manage.removeData = data;
  },
  [QUESTIONS.SET_ASSET_MANAGE_REMOVE_FLAG]: (s, flag: boolean) => {
    s.manage.removeFlag = flag;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
